import { roleReducer } from "../reducer/RoleReducer";

export const reducer = roleReducer;
